export default __webpack_public_path__ + "static/media/sign-up.00210feb.svg";